export const environment = {
    siteId: 1,
    name: 'babylon',
    apiBaseUrl: 'https://api.saparellada.es/api',
    baseUrl: 'https://api.saparellada.es',
    token: '',
    email: 'front@clicktotravel.es',
    password: '-7ribb9k9dw83!HT9iva',
    userPanel: 'admin',
    passPanel: '1234',
    booking_engine_enabled: true, // General switch for booking engine
    booking_engine_top_enabled: true, // Switch for booking engine button in top sliders
    booking_engine_extern: false,
    booking_button_engine_enabled: false, // Button booking engine
    openInNewWindow: false,
    trailingSlash: false,
    multipleMotorsModal: false,
    hotelRequestMotor: false, // Add request hotel motor
    normalizeUrlsToLowercase: false,
    minSizeMobileHeader: 768,
    menuComplexLinks: false,
    booking_engine_widget: false, // Use widget booking engine
    booking_engine_widget_dynamic: false, // widget static down
    dataBase: '../data/',
    sitesIndexFile: 'sites.json',
    fallbackUrl: 'https://babylon.com/',
    organizationName: 'Babylon', //Blog data
    hideUserCentrics: false, //Only for dev on true
};
